import LegalLayout from "../../components/LegalLayout";

const LAST_UPDATE = "2025-09-12";

export default function RechtlichesUndDatenschutz() {
  return (
    <LegalLayout
      title="Rechtliches & Datenschutz"
      subtitle={`Stand: ${LAST_UPDATE}`}
    >
      {/* MVP-Hinweis / Disclaimer */}
      <h2 id="mvp">Hinweis zur Nutzung von Svevana (MVP-Testversion)</h2>
      <p>
        Du nutzt aktuell eine Testversion (MVP) von Svevana. Diese Version befindet sich in aktiver
        Entwicklung und kann Fehler, Ausfälle oder unvollständige Funktionen enthalten. Es besteht
        keine Garantie auf Verfügbarkeit, Datenintegrität oder fehlerfreie Nutzung.
      </p>
      <p>
        <strong>Eigenverantwortung:</strong> Bitte verwende in dieser Testphase keine sensiblen oder
        vertraulichen Informationen. Mit der Nutzung erklärst du dich einverstanden, Svevana auf eigenes
        Risiko zu testen.
      </p>

      <h2 id="betreiber">Betreiber & Kontakt</h2>
      <p>
        <strong>Name:</strong> S. Gabathuler<br />
        <strong>Ort/Land:</strong> Buch, Schweiz<br />
        <strong>E-Mail:</strong>{" "}
        <a href="mailto:feedback@svevana.com">feedback@svevana.com</a>
      </p>

      <h2 id="zweck">Zweck dieser Website</h2>
      <p>
        Private Website (nicht kommerziell). Keine entgeltlichen Angebote. Inhalte werden nach bestem
        Wissen gepflegt, ohne Gewähr für Richtigkeit/Vollständigkeit.
      </p>

      <h2 id="daten">Welche Daten verarbeiten wir?</h2>
      <ul>
        <li>
          <strong>Technische Basisdaten (Server-Logs):</strong> IP-Adresse, Datum/Uhrzeit,
          User-Agent. Dient Stabilität/Sicherheit der Website.
        </li>
        <li>
          <strong>Gespeicherte Daten in der App:</strong> Svevana verarbeitet ausschliesslich die Daten,
          die du aktiv eingibst (z. B. Name, Profilangaben, Reise-Infos, Chat-Beiträge). Speicherung in
          einer Cloud-Datenbank (Supabase) zur Bereitstellung der Kernfunktionen.
        </li>
        <li>
          <strong>Kontakt & Kommunikation:</strong> Mit deiner Registrierung wird deine E-Mail
          gespeichert. Wir nutzen sie, um dich über Freischaltung/Warteliste, neue Funktionen,
          Feedback-Anfragen und Support zu kontaktieren.
        </li>
        <li>
          <strong>Account/Registrierung (falls genutzt):</strong> E-Mail/Profil gemäss App-Funktion
          (Auth via Supabase).
        </li>
      </ul>

      <h2 id="analyse">Analyse & Nutzungsauswertung (Google Analytics 4)</h2>
      <p>
        Zur Verbesserung der Anwendung setzen wir <strong>Google Analytics 4 (GA4)</strong> ein. Es
        werden <em>anonymisierte bzw. pseudonyme Nutzungsdaten</em> (z. B. Seitenaufrufe, Klicks)
        erhoben und ausgewertet. <strong>Persönliche Inhalte</strong> wie Namen, Chat-Nachrichten oder
        Reisedetails werden <strong>nicht</strong> an Google übermittelt.
      </p>
      <p>
        GA4 wird <strong>nur nach deiner Einwilligung</strong> aktiviert. Du kannst deine Entscheidung
        jederzeit über die Cookie-/Tracking-Einstellungen widerrufen (Opt-out).
      </p>

      <h2 id="cookies">Cookies & ähnliche Technologien</h2>
      <p>
        Diese Seite nutzt <strong>technisch notwendige</strong> Cookies/Storage (z. B. Session, Sprache,
        ggf. PWA-Cache), um Grundfunktionen bereitzustellen.
      </p>
      <p>
        <strong>Optionale Cookies/Technologien</strong> für Analytics (GA4) werden erst gesetzt, wenn du
        zustimmst. Ablehnen ist gleichwertig möglich; ein Widerruf ist jederzeit in den
        Cookie-Einstellungen möglich.
      </p>

      <h2 id="anbieter">Drittanbieter & Empfänger</h2>
      <ul>
        <li>
          <strong>Supabase</strong> (Auth/DB/Storage) – Verarbeitung/Hosting gemäss deren Rechenzentrum
          und Verträgen.
        </li>
        <li>
          <strong>Hosting/Deployment</strong> (z. B. Vercel/Alternative) – Auslieferung der Website/App.
        </li>
        <li>
          <strong>E-Mail</strong> (z. B. Postmark/Alternative) – Versand von Systemmails (nur bei Bedarf).
        </li>
        <li>
          <strong>Google Analytics 4</strong> – Nutzungsanalyse <em>nur</em> nach Einwilligung.
        </li>
      </ul>

      <h2 id="dauer">Speicherdauer</h2>
      <p>
        Personenbezogene Daten werden gelöscht, sobald der Zweck entfällt oder du dies verlangst – soweit
        keine gesetzlichen Aufbewahrungspflichten entgegenstehen. In der MVP-Phase können Daten im Zuge
        der Weiterentwicklung geändert oder gelöscht werden.
      </p>

      <h2 id="rechte">Deine Rechte</h2>
      <ul>
        <li>Auskunft, Berichtigung, Löschung, Einschränkung der Bearbeitung</li>
        <li>Widerruf erteilter Einwilligungen mit Wirkung für die Zukunft</li>
        <li>Beschwerderecht bei der zuständigen Datenschutz-Aufsichtsbehörde</li>
      </ul>

      <h2 id="uebermittlung">Übermittlung ins Ausland</h2>
      <p>
        Sofern Dienste im Ausland genutzt werden, stellen wir ein angemessenes Datenschutzniveau sicher.
      </p>

      <h2 id="rechtliches">Urheberrecht & Haftung</h2>
      <p>
        Inhalte dieser Seite unterliegen dem Urheberrecht. Eine Nutzung ausserhalb der App/Website bedarf
        der Zustimmung. Haftung für externe Links ist ausgeschlossen; für verlinkte Inhalte sind deren
        Betreiber verantwortlich.
      </p>

      <h2 id="einwilligung">Einwilligung / Zustimmung</h2>
      <p>
        Durch die Nutzung der MVP-Testversion bestätigst du die obigen Hinweise. Die Verarbeitung deiner
        eingegebenen Daten erfolgt zur Bereitstellung der Funktionen. Die <strong>Nutzungsanalyse
        (GA4)</strong> erfolgt <strong>nur nach deiner separaten Zustimmung</strong> und ist jederzeit
        widerrufbar.
      </p>

      <h2 id="aenderungen">Änderungen</h2>
      <p>Wir passen diese Seite bei Bedarf an. Die jeweils aktuelle Fassung ist hier abrufbar.</p>
    </LegalLayout>
  );
}
